import React, { useState, useEffect, useMemo } from "react";
import RomGallery from "../components/RomGallery";
import ProgressJournal from "../components/ProgressJournal";
import PainChart from "../components/PainChart";
import MotivationChart from "../components/MotivationChart";
import TasksChart from "../components/TasksChart";
import { appVersion } from "../services/constants";
import "../css/Progress.css";
import { getProgress, getPatientInfo, getRomGallery } from "../Api";
import secureLocalStorage from "react-secure-storage";
import { Link } from "react-router-dom";
import { saveAs } from 'file-saver';

const Progress = () => {
  const [patientInfo, setPatientInfo] = useState(null);
  const [romGallery, setRomGallery] = useState([]);
  const [weekNo, setWeekNo] = useState(0);
  const [painLevel, setPainLevel] = useState(0);
  const [motivationLevel, setMotivationLevel] = useState(0);
  const [activityLevel, setActivityLevel] = useState(0);

  const getPatientId = () => {
    return secureLocalStorage.getItem("patient_id");
  };

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const response = await getProgress(getPatientId());
        setWeekNo(response.patient_info.week_no);
        setPatientInfo(response.patient_info);
        if (response.latest_pain_scale) {
          setPainLevel(response.latest_pain_scale);
        }
        if (response.latest_motivation_level) {
          setMotivationLevel(response.latest_motivation_level);
        }
        if (response.latest_activity_level) {
          setActivityLevel(response.latest_activity_level);
        }
      } catch (error) {
        console.error("Error fetching progress:", error);
      }
    };

    fetchProgress();
  }, []);

  useEffect(() => {
    const fetchRomGallery = async () => {
      try {
        const response = await getRomGallery(getPatientId());
        setRomGallery(response);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    fetchRomGallery();
  }, []);

  const currentDate = useMemo(() => new Date(), []);

  const generateWeekAndStatus = useMemo(() => {
    const surgeryDate = new Date(patientInfo?.start_date);
    const weeksDiff = Math.abs(patientInfo?.week_no);

    let message = "";
    let typeStr = "";
    if (patientInfo?.is_preventive == 1) {
      message = `Week ${weeksDiff} of Prehab`;
      typeStr = "Prevention";
    }

    if (patientInfo?.is_preventive == 0) {
      if (surgeryDate > currentDate) {
        typeStr = "Pre-Op";
        message = `${weeksDiff} ${
          weeksDiff === 1 ? "Week" : "Weeks"
        } Until Your Big Day`;
      } else {
        typeStr = "Post-Op";
        message = `Week ${weeksDiff} of Your Recovery`;
      }
    }

    return { message, typeStr };
  }, [patientInfo, currentDate]);

  const exportToCSV = () => {
    const parseValue = (value) => {
      if (Array.isArray(value)) {
        return value.map(item => JSON.stringify(item)).join("; ");
      }
      return JSON.stringify(value);
    };

    const csvData = [
      ["Metric", "Value"],
      ["Pain Level", parseValue(painLevel)],
      ["Motivation Level", parseValue(motivationLevel)],
      ["Activity Level", parseValue(activityLevel)],
    ];
    console.log(csvData);

    const csvContent = csvData.map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "progress_report.csv");
  };

  return (
    <main className="main-content progress-main">
      <div className="main fade-med">
        <div className="headContents">
          <div className="headContent-left">
            <>
              {/* <h2 className="heading">{generateWeekAndStatus.message}</h2> */}
              <h3 className="card-title">Hello {patientInfo?.patient_name},</h3>
              <p className="subHeading">
                <span>{generateWeekAndStatus.typeStr}</span> -{" "}
                {currentDate.toDateString()}
              </p>
            </>
          </div>
          <div className="headContent-right">
            <div className="streakContainer">
              <h3 className="card-title">Summary Report</h3>
              {/* <div className="filterExportContainer">
                <select className="timeFilterDropdown">
                  <option value="week">This Week</option>
                  <option value="month">This Month</option>
                  <option value="year">This Year</option>
                </select>
                <button className="exportButton" onClick={exportToCSV}>
                  Export
                  <img src="../export.svg" width="20" alt="Chat"></img>
                </button>
              </div> */}
            </div>

            {/* <div className="romContainer">
              <img
                className="headerContentSeparator"
                src="../headerContentSeparator.svg"
              />
              <h4>ROM Personal Best</h4>
              <p className="romBest">
                {romGallery.length > 0
                  ? Math.max(...romGallery.map((item) => item.rom_value))
                  : 0}
                °
              </p>s
            </div> */}
          </div>
        </div>
        <RomGallery romGallery={romGallery} />
        {/* <ProgressJournal /> */}
        <PainChart painLevel={painLevel} />
        <MotivationChart motivationLevel={motivationLevel} />
        <TasksChart activityLevel={activityLevel} />
        <Link to="/logout" className="logout-button app-version">
          <b>({appVersion})</b> Logout
        </Link>
      </div>
    </main>
  );
};

export default Progress;
